export const SendStep = {
  CONTACT: 'contact',
  DETAILS: 'details',
  REVIEW: 'review',
  COMPLETE: 'complete',
  APPROVAL: 'approval',
} as const

export type SendStep = (typeof SendStep)[keyof typeof SendStep]

export const FiatSendSteps = {
  BENEFICIARY: 'beneficiary',
  DETAILS: 'details',
  CONFIRMATION: 'confirmation',
  EOF: 'eof',
} as const

export type FiatSendStep = (typeof FiatSendSteps)[keyof typeof FiatSendSteps]

export const ConvertStep = {
  DETAILS: 'details',
  REVIEW: 'review',
  COMPLETE: 'complete',
} as const

export type ConvertStep = (typeof ConvertStep)[keyof typeof ConvertStep]
